import cx from 'classix';
import { Entry } from 'contentful';

export const getFullWidthBackgroundStyles = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'>,
) => {
  return cx(
    '-mx-2 sm:-mx-4.5',
    'px-2 py-6 text-center',
    entry.fields.backgroundColor === 'white' && 'bg-white',
    entry.fields.backgroundColor === 'grey' && 'bg-gray-50',
    entry.fields.backgroundColor === 'light-blue' && 'bg-blue-50',
  );
};
